/**
 * Reserva DatePicker
 *
 * Generalisierte Version des IBE1 Datepickers zur Verwendung in beliebigen Webseiten.
 */

var Backbone = require('backbone');

/**
 * ReservaDaysModel
 */
var ReservaDaysModel = Backbone.Model.extend({
	defaults: function() { return {
		days: [],
		nights: [],
		name: '',
	}},

	reset: function() {
		this.set(this.defaults());
	},
});

module.exports = ReservaDaysModel;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/engine/ReservaDaysModel.js